import { useEffect, useRef } from "react";
import useFetch from "./useFetch";
import { AGENT_ACTIVITY_POLE_REQUEST } from "../utils/ApiUrls";

// const HEARTBEAT_INTERVAL_MS = 30000; // 30s
// const HEARTBEAT_INTERVAL_MS = 10000; // 10s
// const HEARTBEAT_INTERVAL_MS = 5000; // 5s
const HEARTBEAT_INTERVAL_MS = 60000; // 5s

export default function useAgentHeartbeat(auth, tabId, onMultipleTabsDetected, onStatusUpdate,setOnlineStatus,getOnlineStatus) {
  const fetchData = useFetch();
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!auth?.roles || !tabId) return;

    const sendHeartbeat = (event = "heartbeat") => {
      // don't ping if tab isn't visible (except explicit tab_hidden signal)
      if (event === "heartbeat" && document.visibilityState !== "visible") return;

      if (localStorage.getItem('IsLoggedIn') === 'true') {
        console.log('logged in')
        fetchData(
          "post",
          { status: "available", usertype: "agent", event, tab_id: tabId },
          AGENT_ACTIVITY_POLE_REQUEST
        )
          .then((res) => {
            if (res?.multiple_tabs) {
              onMultipleTabsDetected?.();
            }
            const getOnlineStatusColour = localStorage.getItem("onlineStatusColour") || "initial_status";
            // alert(`${res?.current_active_status} and  ${getOnlineStatusColour}`)
            // if (res?.current_active_status!==getOnlineStatusColour) {
            if (res?.current_active_status) {
              if(res?.current_active_status==="waiting" || res?.current_active_status==="incall"){
                // onStatusUpdate?.("avaialable");
                // setOnlineStatus?.("avaialable");
              }else{
                onStatusUpdate?.(res.current_active_status);
                setOnlineStatus?.(res.current_active_status);
              }
            }
          })
          .catch(() => {
            // swallow network errors, next tick will retry
          });
      }
      else {
        stopPolling();
      }

    };

    const startPolling = () => {
      if (intervalRef.current) return; // already running
      sendHeartbeat("heartbeat"); // fire immediately on start/resume
      intervalRef.current = setInterval(() => sendHeartbeat("heartbeat"), HEARTBEAT_INTERVAL_MS);
    };

    const stopPolling = () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        startPolling();
      } else {
        stopPolling();
        // explicit "away" signal instead of waiting for the sweep to infer it
        // sendHeartbeat("tab_hidden");
      }
    };

    // start immediately if tab is currently visible
    if (document.visibilityState === "visible") {
      startPolling();
    }

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      stopPolling();
    };
  }, [auth, tabId]);
}